var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatssApp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 50,
    fill: "#34C759"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_362_2088)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.991,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.2422 29.9609C49.388 29.9609 50.5338 29.9609 51.6797 29.9609C59.513 30.9407 65.0989 35.0032 68.4375 42.1484C69.2419 44.1159 69.7497 46.1472 69.9609 48.2422C69.9609 49.388 69.9609 50.5338 69.9609 51.6797C68.9812 59.513 64.9187 65.0989 57.7734 68.4375C55.8059 69.2419 53.7747 69.7497 51.6797 69.9609C50.5338 69.9609 49.388 69.9609 48.2422 69.9609C45.0054 69.645 42.0105 68.6163 39.2578 66.875C39.138 66.8029 39.0077 66.7638 38.8672 66.7578C36.3364 67.5493 33.8103 68.3566 31.2891 69.1797C32.0504 66.6999 32.8577 64.213 33.7109 61.7188C31.5891 58.6996 30.3391 55.3533 29.9609 51.6797C29.9609 50.5338 29.9609 49.388 29.9609 48.2422C30.9407 40.4089 35.0032 34.823 42.1484 31.4844C44.1159 30.68 46.1472 30.1722 48.2422 29.9609ZM41.7578 39.1797C42.3313 39.1667 42.9042 39.1797 43.4766 39.2188C43.6745 39.2591 43.8438 39.3502 43.9844 39.4922C44.8511 41.3163 45.6193 43.1783 46.2891 45.0781C46.1895 45.5248 45.9942 45.9284 45.7031 46.2891C45.3204 46.6648 44.9559 47.0554 44.6094 47.4609C44.3605 47.7577 44.2823 48.0963 44.375 48.4766C46.2751 51.8868 49.0485 54.2957 52.6953 55.7031C53.0525 55.7724 53.391 55.7203 53.7109 55.5469C54.3045 54.9014 54.8384 54.2113 55.3125 53.4766C55.572 53.0991 55.9236 52.8647 56.3672 52.7734C58.2795 53.5017 60.1154 54.3871 61.875 55.4297C62.1812 57.9555 61.1525 59.6873 58.7891 60.625C57.708 61.092 56.5882 61.2222 55.4297 61.0156C51.0209 60.1205 47.2579 58.0763 44.1406 54.8828C42.6358 53.2776 41.2816 51.5588 40.0781 49.7266C39.2402 48.4373 38.6934 47.0311 38.4375 45.5078C38.2003 43.2501 38.8904 41.336 40.5078 39.7656C40.9017 39.5034 41.3184 39.308 41.7578 39.1797Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_362_2088"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(30 30)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatssApp);
export default __webpack_public_path__ + "static/media/WhatssApp.00d070930b716b000e8e91d647984ed4.svg";
export { ForwardRef as ReactComponent };